import styled from 'styled-components';
import { themeColors } from '../../styles/globalStyleVars';
import { TypographyStyled } from './Typography';

export const TypographyLineLimit = styled(TypographyStyled)<{
  $lineLimit?: number;
  $fontColor: themeColors;
  $action?: boolean;
}>`
  color: ${({ $fontColor }) => $fontColor};
  overflow: hidden;
  display: -webkit-box;
  ${({ $lineLimit }) =>
    $lineLimit &&
    `-webkit-line-clamp: ${$lineLimit}`}; /* number of lines to show */
  ${({ $lineLimit }) => $lineLimit && `line-clamp: ${$lineLimit}`};

  -webkit-box-orient: ${({ $action }) => ($action ? 'horizontal' : 'vertical')};
`;
